<template>
  <div v-if="isArray">
    <feature-popup-parsed-attr-value v-if="attrValParsed.length <= 1" :attrVal="attrValParsed[0]">
    </feature-popup-parsed-attr-value>
    <ul v-else>
      <li v-for="(item, index) in attrValParsed" :key="'arr-' + index">
        <feature-popup-parsed-attr-value :attrVal="item"></feature-popup-parsed-attr-value>
      </li>
    </ul>
  </div>
  <div v-else>
    <pre class="feature-popup-preformatted">{{attrValParsed}}</pre>
  </div>
</template>

<script>
export default {
  props: ['attrVal'],
  name: "FeaturePopupParsedAttrValue",
  computed: {
    attrValParsed() {
      try {
        return JSON.parse(this.attrVal);
      } catch (e) {
        return this.attrVal;
      }
    },
    isArray() {
      return Array.isArray(this.attrValParsed);
    }
  }
};
</script>
